import React, { useEffect, useState } from "react";
import "./program.scss";
import { postGrantBuilder } from "../../../utils/services";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const Program = () => {
  const [projectName, setProjectName] = useState("");
  const [concept, setConcept] = useState("");
  const [email, setEmail] = useState("");
  const [telegramHandler, setTelegramHandler] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [websiteURL, SetWebsiteURl] = useState("");
  const [xHandler, setXHandler] = useState("");
  const [isXFocused, setIsXFocused] = useState(false);
  const [applicationSuccessModal, SetApplicationSuccessModal] = useState(false);
  const [applicationError, SetApplicationError] = useState(false);
  const location = useLocation();

  const projectNameRegex = /^[A-Za-z0-9\s]*$/;
  const conceptRegex = /^[A-Za-z0-9\s.,!?'"()\-:/]*$/;
  const emailAsciiRegex = /^[\x00-\x7F]*$/;
  const websiteURLInputRegex = /^[A-Za-z0-9.:\/\-]*$/;
  const userNameRegex = /^[A-Za-z0-9_]*$/;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(email);

  const websiteRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
  const trimmedWebsiteURL = websiteURL?.trim();
  const isValidWebsite = websiteRegex?.test(trimmedWebsiteURL);

  const telegramRegex = /^[a-zA-Z0-9_]{5,32}$/;
  const trimmedTelegram = telegramHandler.trim();
  const isValidTelegramUsername = telegramRegex.test(trimmedTelegram);

  const xRegex = /^[A-Za-z0-9_]{1,15}$/;
  const trimmedX = xHandler.trim();
  const isValidXUsername = xRegex.test(trimmedX);

  const handlePostGrantBuilder = async () => {
    if (!projectName || projectName?.length < 3) {
      SetApplicationError(true);
      return;
    }
    if (!concept || concept?.length < 50) {
      SetApplicationError(true);
      return;
    }
    if (!email || !isValidEmail) {
      SetApplicationError(true);
      return;
    }

    if (websiteURL && !isValidWebsite) {
      SetApplicationError(true);
      return;
    }

    if (telegramHandler && !isValidTelegramUsername) {
      SetApplicationError(true);
      return;
    }

    if (xHandler && !isValidXUsername) {
      SetApplicationError(true);
      return;
    }

    let normalizedWebsite = trimmedWebsiteURL || "";
    if (
      trimmedWebsiteURL &&
      !trimmedWebsiteURL.startsWith("http://") &&
      !trimmedWebsiteURL.startsWith("https://")
    ) {
      normalizedWebsite = `https://${trimmedWebsiteURL}`;
    }

    try {
      const payload = {
        projectName: projectName,
        concept: concept,
        email: email,
        websiteURL: normalizedWebsite,
        telegram: telegramHandler,
        xHandle: xHandler
      };
      const response = await postGrantBuilder(payload);
      if (response) {
        SetApplicationSuccessModal(true)
        SetApplicationError(false)
        setProjectName("");
        setConcept("");
        setEmail("");
        setTelegramHandler("");
        SetWebsiteURl("");
        setXHandler("");
      }

    } catch (error) {
      console.log("error while posting grant builder", error);
    }
  };

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  }, [location]);
  return (
    <>
      <div className="outter_layer_builders">
        <section className="main-side-program" id="program">
          <div className="custom-container">
            <div className="main-program">
              <div className="left-program">
                <h4>Waitlist now open: <br />
                  Rain builder grants program</h4>
                <p>
                  We provide the funding, technical support, and ecosystem access needed to bring your project to life.
                </p>
              </div>
              <div className="right-program">
                <h2>Apply for a Grant</h2>
                <div className="option-field">
                  <h3>
                    Project Name<span>*</span>
                  </h3>
                  <input
                    placeholder="Enter your project name"
                    type="text"
                    id="fname"
                    name="fname"
                    style={{
                      border: applicationError && (!projectName || projectName?.length < 3) ? "1px solid red" : ""
                    }}
                    value={projectName}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (projectNameRegex.test(value)) {
                        setProjectName(value);
                      }
                    }}
                    className="m-0"
                  />
                  {applicationError && !projectName ? <p className="error-text-form">Project Name is required</p> : applicationError && projectName?.length < 3 ? <p className="error-text-form">Project name must be at least 3 characters</p> : ""}
                </div>
                <div className="option-field">
                  <h3>
                    The Concept<span>*</span>
                  </h3>
                  <textarea
                    id="w3review"
                    name="w3review"
                    rows="4"
                    placeholder="Describe your idea and how it utilizes the protocol"
                    cols="50"
                    style={{
                      border: applicationError && (!concept || concept?.length < 50) ? "1px solid red" : ""
                    }}
                    value={concept}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (conceptRegex.test(value)) {
                        setConcept(value);
                      }
                    }}
                  ></textarea>
                  {applicationError && !concept ? <p className="error-text-form">Concept is required</p> : applicationError && concept?.length < 50 ? <p className="error-text-form">{50 - concept?.length} more characters required</p> : ""}
                </div>
                <div className="option-field">
                  <h3>
                    Website URL
                  </h3>
                  <input
                    placeholder="Enter your project website URL"
                    type="text"
                    id="fname"
                    name="fname"
                    value={websiteURL}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (websiteURLInputRegex.test(value)) {
                        SetWebsiteURl(value);
                      }
                    }}
                    className="m-0"
                    style={{
                      border: applicationError && websiteURL && !isValidWebsite ? "1px solid red" : ""
                    }}
                  />
                  {applicationError && websiteURL && !isValidWebsite ? (
                    <p className="error-text-form">Invalid Website URL</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="option-field">
                  <h3>
                    Contact Email<span>*</span>
                  </h3>
                  <input
                    placeholder="Email address"
                    type="text"
                    id="fname"
                    name="fname"
                    style={{
                      border: applicationError && (!email || !isValidEmail) ? "1px solid red" : ""
                    }}
                    value={email}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (emailAsciiRegex.test(value)) {
                        setEmail(value);
                      }
                    }}
                    className="m-0"
                  />
                  {applicationError && !email ? <p className="error-text-form">Email is required</p> : applicationError && !isValidEmail ? <p className="error-text-form">Email is Invalid</p> : ""}
                </div>
                <div className="twice-fields">
                  <div className="option-field">
                    <h3>
                      Telegram Handle
                    </h3>
                    <input
                      placeholder="@username"
                      type="text"
                      value={telegramHandler || isFocused ? `@${telegramHandler}` : ""}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      onChange={(e) => {
                        let value = e.target.value.replace("@", "").replace(/\s/g, "");
                        if (userNameRegex.test(value)) {
                          setTelegramHandler(value);
                        }
                      }}
                    />
                    {applicationError && telegramHandler && !isValidTelegramUsername ? (
                      <p className="error-text-form">Invalid Telegram Username</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="option-field">
                    <h3>
                      X Handle
                    </h3>
                    <input
                      placeholder="@username"
                      type="text"
                      value={xHandler || isXFocused ? `@${xHandler}` : ""}
                      onFocus={() => setIsXFocused(true)}
                      onBlur={() => setIsXFocused(false)}
                      onChange={(e) => {
                        let value = e.target.value.replace("@", "").replace(/\s/g, "");
                        if (userNameRegex.test(value)) {
                          setXHandler(value);
                        }
                      }}
                      className="m-0"
                      style={{
                        border:
                          applicationError &&
                            xHandler &&
                            !isValidXUsername
                            ? "1px solid red"
                            : ""
                      }}
                    />
                    {applicationError && xHandler && !isValidXUsername ? (
                      <p className="error-text-form">Invalid X Username</p>
                    ) : (
                      ""
                    )}
                  </div>

                </div>
                <button onClick={handlePostGrantBuilder}>Submit Application</button>
              </div>
            </div>
          </div>
        </section>
      </div>


      <Modal
        className="token contactform-modal"
        show={applicationSuccessModal}
        centered
      >
        <Modal.Header >
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal1">
            <div className="inner_side_modal111">
              <div className="theme-img ">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                  <rect width="64" height="64" rx="32" fill="#DAD9D9" fill-opacity="0.1" />
                  <path d="M48.9056 23.9461L28.4256 44.4261C28.3067 44.5451 28.1656 44.6395 28.0102 44.7039C27.8548 44.7683 27.6882 44.8015 27.52 44.8015C27.3518 44.8015 27.1852 44.7683 27.0298 44.7039C26.8745 44.6395 26.7333 44.5451 26.6144 44.4261L17.6544 35.4661C17.4142 35.2259 17.2793 34.9001 17.2793 34.5605C17.2793 34.2208 17.4142 33.8951 17.6544 33.6549C17.8946 33.4147 18.2203 33.2798 18.56 33.2798C18.8997 33.2798 19.2254 33.4147 19.4656 33.6549L27.52 41.7109L47.0944 22.1349C47.3346 21.8947 47.6603 21.7598 48 21.7598C48.3397 21.7598 48.6654 21.8947 48.9056 22.1349C49.1458 22.3751 49.2807 22.7008 49.2807 23.0405C49.2807 23.3801 49.1458 23.7059 48.9056 23.9461Z" fill="#DAD9D9" />
                </svg>
              </div>
              <h2>Application Received!</h2>
              <h5>Thank you for applying to the Grants Program. Our ecosystem team will review your proposal and reach out via Telegram or Email to discuss the next steps.</h5>
            </div>
            <div className="inner_side_modal1">
              <button onClick={() => SetApplicationSuccessModal(false)} className="close" >
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Program;










